const url = '/permissions';
const Provider = 'Permissions';
const dbModel = 'Permissions';

export { url, Provider, dbModel };
